import moment from 'moment'

export const formatTime = function (value) {
  if (!value) return value
  return moment(value).format('LT')
}
